<div class="inputs-wrapper">
  <app-upload-shapefile
    [displayConfig]="{
      showTitle: true,
      showDescription: true,
      titlePosition: 'side',
      titleBold: true,
      customTitle: 'Áreas de Interesse',
      customDescription:
        'Selecione o tipo de arquivo e faça o upload das áreas que deseja analisar',
      showFileTypeSelector: true,
      enabledFileTypes: enabledFileTypes,
      module: 'compliance',
    }"
    (fileUploaded)="onFileUploaded($event)"
    (originalFileName)="onOriginalFileName($event)"
    (fileTypeChanged)="onFileTypeChanged($event)"
  ></app-upload-shapefile>
  <mat-divider class="divider"></mat-divider>
  <app-file-params-form
    [fileName]="uploadedFileName ?? undefined"
    [originalFileName]="originalFileName ?? undefined"
    [isCarRequired]="false"
    [showCarField]="fileType === 'spreadsheet'"
    module="compliance"
  ></app-file-params-form>
  <mat-divider class="divider"></mat-divider>
  <div class="buttons">
    <button mat-stroked-button (click)="onNavigateUp()">
      <mat-icon>arrow_back</mat-icon>
      Cancelar
    </button>

    <button [disabled]="isLoading" mat-flat-button (click)="onSubmit()">
      @if (!isLoading) {
        <mat-icon>save</mat-icon>
      }
      @if (isLoading) {
        <mat-icon>
          <mat-spinner matIcon diameter="18"></mat-spinner>
        </mat-icon>
      }
      Solicitar
    </button>
  </div>
</div>
